/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusDiscountMarkupDto
 */
export interface NovitusDiscountMarkupDto {
    /**
     * Typ rabatu/narzutu
     * @type {string}
     * @memberof NovitusDiscountMarkupDto
     */
    type: NovitusDiscountMarkupDtoTypeEnum;
    /**
     * Nazwa/opis rabatu (1-20 znaków)
     * @type {string}
     * @memberof NovitusDiscountMarkupDto
     */
    name?: string;
    /**
     * Wartość rabatu/narzutu
     * @type {string}
     * @memberof NovitusDiscountMarkupDto
     */
    value: string;
}


/**
 * @export
 */
export const NovitusDiscountMarkupDtoTypeEnum = {
    percent_discount: 'percent_discount',
    percent_markup: 'percent_markup',
    value_discount: 'value_discount',
    value_markup: 'value_markup'
} as const;
export type NovitusDiscountMarkupDtoTypeEnum = typeof NovitusDiscountMarkupDtoTypeEnum[keyof typeof NovitusDiscountMarkupDtoTypeEnum];


/**
 * Check if a given object implements the NovitusDiscountMarkupDto interface.
 */
export function instanceOfNovitusDiscountMarkupDto(value: object): value is NovitusDiscountMarkupDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusDiscountMarkupDtoFromJSON(json: any): NovitusDiscountMarkupDto {
    return NovitusDiscountMarkupDtoFromJSONTyped(json, false);
}

export function NovitusDiscountMarkupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusDiscountMarkupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'],
    };
}

export function NovitusDiscountMarkupDtoToJSON(value?: NovitusDiscountMarkupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'name': value['name'],
        'value': value['value'],
    };
}

